import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles.css";

export default function UserAgreement() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="agreement-page"
      style={{ padding: "16px 12px", maxWidth: "960px", margin: "0 auto" }}
    >
      <h1>伴知宠服务协议</h1>

      <p>更新日期：2026年 3月 30日</p>
      <p>生效日期：2026年 3月 30日</p>

      <p>
        <strong>
          感谢您选择注册并使用伴知宠，在使用“伴知宠”软件及相关服务前，请您认真阅读本协议（特别是以加粗方式提示您注意的可能存在免除或者限制责任等重要内容的条款），并确认承诺同意遵守本协议之全部约定。本协议由您与知宠派智能科技（杭州）有限公司（包括其关联机构，以下合称“本公司”）于您点击同意本协议之时在浙江省杭州市余杭区签署并生效
        </strong>
        。
      </p>

      <h2>一、协议条款的确认及接受</h2>
      <p>
        <strong>
          1.1 伴知宠（包括伴知宠APP、伴知宠官网、伴知宠智能陪伴车、伴知宠智能项圈，以下简称"本平台"或“伴知宠”）由知宠派智能科技（杭州）有限公司（包括其关联机构，以下合称“本公司”）运营并享有完全的所有权及知识产权等权益，伴知宠提供的服务将完全按照其发布的条款和操作规则严格执行
        </strong>
        。
      </p>
      <p>
        <strong>
          1.2 您确认同意本协议所有条款并完成注册程序时，本协议在您与本公司间成立并发生法律效力，同时您成为伴知宠正式用户。如您对本服务协议或协议的任何部分存有任何异议，应终止注册程序（或停止使用伴知宠服务）。
        </strong>
      </p>

      <h2>二、账号注册及使用规则</h2>
      <p>
        <strong>
          2.1 您须对在伴知宠的注册信息的真实性、合法性、有效性承担全部责任。您理解并承诺，您所设置的账号不得违反国家法律法规及伴知宠的相关规则，您的账号名称、头像和简介等注册信息及其他个人信息中不得出现违法和不良信息，您不得冒充他人/其他组织或使用他人/其他组织名义（包括但不限于冒用他人/其他组织姓名、名称、字号、头像等足以让人引起混淆的方式）开设账号；不得利用他人/其他组织的名义发布任何信息；不得恶意使用注册账户导致其他用户误认；否则伴知宠有权立即停止提供服务，收回账号并由您独自承担由此而产生的一切法律责任
        </strong>
        。
      </p>
      <p>
        <strong>
          2.2 您在“伴知宠”注册的账号仅限于您本人使用，未经本公司书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果本公司发现或者有合理理由认为使用者并非账号初始注册人，为保障账号安全，本公司有权立即暂停或终止向该注册账号提供服务，并有权永久禁用该账号。
        </strong>
      </p>
      <p>
        <strong>
          2.3 依照国家相关法律法规的规定，为使用“伴知宠”软件及相关服务的部分功能，您需要按照相关法律规定完成真实身份信息认证，并注意及时更新相关信息。若您提交的材料或提供的信息不准确、不真实、不规范或本公司有理由怀疑为错误、不实、不合法的资料，则公司有权拒绝为您提供相关功能，您可能无法使用“伴知宠”软件及相关服务或在使用过程中部分功能受到限制
        </strong>
        。
      </p>
      <p>
        2.4 您有责任维护个人账号、密码的安全性与保密性，并对您以注册账号名义所从事的活动承担全部法律责任，包括但不限于您在“伴知宠”软件及相关服务上进行的任何数据修改、言论发表、款项支付等操作行为可能引起的一切法律责任。您应高度重视对账号与密码的保密，在任何情况下不向他人透露账号及密码。若发现他人未经许可使用您的账号或发生其他任何安全漏洞问题时，您应当立即通知本公司。
      </p>
      <p>
        2.5 如您在丢失账号或遗忘密码时，您可遵照本公司的申诉途径及时申诉请求找回账号或密码。您理解并认可，本公司的密码找回机制仅需要识别申诉单上所填资料与系统记录资料具有一致性，而无法识别申诉人是否系真正账号有权使用者。本公司特别提醒您应妥善保管您的账号和密码。如因您保管不当等自身原因或其他不可抗因素导致遭受盗号或密码丢失，您将自行承担相应责任。
      </p>
      <p>
        2.6 除自行注册“伴知宠”账号外，您也可选择通过授权使用您合法拥有的实名注册的第三方软件或平台用户账号登录使用“伴知宠”软件及相关服务，但第三方软件或平台对此有限制或禁止的除外。当您以前述已有账号登录使用时，应保证相应账号已进行实名注册登记，并同样适用本协议中的相关条款。
      </p>
      <p>
        2.7 您承诺不得以任何方式利用伴知宠直接或间接从事违反中国法律、社会公德的行为，伴知宠有权对违反上述承诺的内容予以删除。
      </p>
      <p>
        2.8 当您完成“伴知宠”的账号注册、登录并进行合理和必要的身份验证后，您可随时浏览、修改自己提交的个人身份信息。您理解并同意，出于安全性和身份识别（如账号或密码找回申诉服务等）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。您也可以申请注销账号，本公司会在完成个人身份、安全状态、设备信息、侵权投诉等方面的合理和必要的验证后协助您注销账号，并依照您的要求删除有关您账号的一切信息，法律法规另有规定的除外。
        <strong>但您仍应对您在注销账号前且使用伴知宠服务期间的行为承担相应责任</strong>
        。
      </p>
      <p>
        2.9 伴知宠有权对您使用伴知宠的情况进行审查和监督，如您在使用伴知宠时违反任何上述规定，伴知宠或其授权方有权要求您改正或直接采取一切必要的措施（包括但不限于更改或删除您的内容、暂停或终止您使用伴知宠的权利）以减轻您的不当行为造成的影响。
      </p>
      <p>
        2.10 伴知宠平台提供亲友邀请关注功能。当您希望邀请您的亲友与您共同使用本产品的功能并共享平台信息或服务时，您只需要分享邀请二维码，您的亲友的伴知宠账号接受邀请并同意关注后，即可访问邀请二维码对应的宠物空间。双方将共享彼此账号下的重要个人信息和服务功能。您选择使用本功能前应预先知晓：您同意伴知宠将您的相关个人信息、个人相册内容与亲友进行共享，对于您和您的亲友之间在关注空间、共享信息过程中所发生或可能发生的包括个人信息泄露或任何心理、生理上的伤害或经济上的损失，伴知宠不承担任何责任。请注意，宠物空间的关系权限可分为创建者及亲友两种关系。创建者默认是管理员。管理员拥有宠物空间的管理权限，可控制其他用户对空间内信息的上传下载及分享，可邀请、编辑其他亲友团成员，可删除创建者外所有亲友；普通亲友关系可正常查看宠物空间信息。
      </p>
      <p>
        2.11 伴知宠的宠参谋功能提供AI育宠顾问服务。AI育宠顾问基于伴知宠育宠大模型研发。用户须在对话框输入文本信息，伴知宠会基于用户输入输出相应的内容作为响应。伴知宠会收集和分析用户的输入及相应输出信息，以提高识别和响应能力，改进本服务的智能性和内容质量。您使用本服务前应预先知晓：本服务下的输出不代表专业意见，不能代替专业人士向您解答对应疑问。相关观点也仅限于算法所触达有限数据呈现的供您参考的结果，并不代表伴知宠立场。由于机器学习特性，就相同的输入可能产生不同的输出结果，请您注意甄别。您根据输出的内容所作出的任何判断或者据此作出的后续相关操作行为，以及由此带来的后果和责任均由您自行承担，请科学理性认识和依法使用本服务。更多详情，请参见
        <Link to="/user-agreement/pet-ai-service" className="agreement-link">
          《伴知宠育宠大模型服务协议》
        </Link>
      </p>
      {/*<p>*/}
      {/*  2.12 伴知宠向用户提供付费的会员服务，即会员可在伴知宠应用内专享的会员权益及特色服务，包括但不限于长视频上传、享受更多AI模版生成视频、更大存储空间等，伴知宠有权根据市场情况进行会员权益及特色会员服务的全部或部分变更、调整、取消、增加。更多详情，请参见《伴知宠会员服务协议》*/}
      {/*</p>*/}

      <h2>三、用户个人信息保护</h2>
      <p>
        3.1 本公司与您一同致力于您个人信息（即能够独立或与其他信息结合后识别您身份的信息）的保护，保护用户个人信息是本公司的基本原则之一。在使用“伴知宠”软件及相关服务的过程中，您可能需要提供您的个人信息（包括但不限于手机号码、宠物信息、设备信息等），以便本公司向您提供更好的服务和相应的技术支持。本公司将依法保护您浏览、修改、删除相关个人信息以及撤回授权的权利，并将运用加密技术、去标识化处理等其他与“伴知宠”软件及相关服务相匹配的技术措施及其他安全措施保护您的个人信息，更多关于用户个人信息保护的内容，请参见
        <Link to="/privacy-policy" className="agreement-link">
          《伴知宠隐私政策》
        </Link>
        。
      </p>

      <h2>四、用户行为规范</h2>
      <p>
        4.1 您制作、评论、发布、传播的信息（包括但不限于上传至“伴知宠”平台的未公开的私密内容）应自觉遵守《中华人民共和国网络安全法》、《互联网信息服务管理办法》、《网络信息内容生态治理规定》、《互联网新闻信息服务管理规定》等法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚和信息真实性等要求，否则本公司有权立即采取相应处理措施。
        <strong>您同意并承诺不制作、复制、发布、传播下列信息</strong>
        ：
      </p>
      <p>（1）反对宪法确定的基本原则的；</p>
      <p>（2）危害国家安全，泄露国家秘密的；</p>
      <p>（3）颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；</p>
      <p>（4）损害国家荣誉和利益的；</p>
      <p>（5）党政相关内容表述错误的；</p>
      <p>（6）宣扬恐怖主义、极端主义的；</p>
      <p>（7）宣扬民族仇恨、民族歧视，破坏民族团结的；</p>
      <p>（8）煽动地域歧视、地域仇恨的；</p>
      <p>（9）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p>（10）任何组织、个人讲经讲道，转发、链接相关内容，开展宗教教育培训，发布宗教活动，以宗教名义开展募捐的；</p>
      <p>（11）发布、泄露自己所接触和知悉的军事秘密或其他涉军涉警内容的；</p>
      <p>（12）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；</p>
      <p>（13）含有任何性或性暗示或其他低俗类信息的；</p>
      <p>（14）散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
      <p>（15）危害网络安全、利用网络从事危害国家安全、荣誉和利益的；</p>
      <p>（16）侮辱或者诽谤他人，侵害他人合法权益的；</p>
      <p>（17）对他人进行暴力恐吓、威胁，实施人肉搜索的；</p>
      <p>（18）涉及他人隐私、个人信息或资料的；</p>
      <p>（19）散布污言秽语，损害社会公序良俗的；</p>
      <p>（20）涉及他人隐私、个人信息或资料的，侵害他人名誉权、肖像权、姓名权、知识产权、商业秘密等合法权利的；</p>
      <p>（21）含有其他侵犯其他用户或其他第三方合法权益内容的信息；</p>
      <p>（22）散布违法广告、商业广告，类似商业招揽信息、过度营销信息、垃圾信息或被国家机认定为违法广告或违法信息的内容；</p>
      <p>（23）使用本平台常用语言文字以外的其他语言文字评论的；</p>
      <p>（24）与所评论的信息毫无关系的；</p>
      <p>（25）所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；</p>
      <p>（26）侵害未成年人合法权益或者损害未成年人身心健康的；</p>
      <p>（27）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：</p>
      <p>a. 任何暴力和/或自残行为内容；</p>
      <p>b. 任何威胁生命健康、利用刀具等危险器械表演的危及自身或他人人身及/或财产权利的内容；</p>
      <p>c.怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容；</p>
      <p>（28）其他含有违反法律法规、政策及公序良俗、干扰“伴知宠”正常运营或侵犯其他用户或第三方合法权益内容的信息</p>
      <p>（29）其他含有我们认为不适合展示或印刷的内容(包括宠物空间场景)。</p>
      <p>
        4.2 本公司公示投诉举报渠道，您可通过本公司公示的联系邮箱(support@zhichongpai.com)、APP内的意见反馈功能或者APP内的举报功能向公司投诉、举报各类违法违规行为、违法传播活动、违法有害信息等内容，本公司将及时受理和处理您的投诉举报，以共同营造风清气正的网络空间。向公司投诉、举报各类违法违规行为、违法传播活动、违法有害信息等内容，本公司将及时受理和处理您的投诉举报，以共同营造风清气正的网络空间。
      </p>
      <p>
        4.3 未经伴知宠同意禁止进行商业性行为：您承诺未经伴知宠另行书面同意，不能利用伴知宠平台进行销售、广告或其他任何牟利性行为。若您违反此约定，伴知宠将依法追究您的违约责任，由此给伴知宠造成损失的，伴知宠保留要求您承担赔偿责任的权利。
      </p>
      <p>
        4.4 在您使用伴知宠AI育宠顾问服务和AI生成视频时，伴知宠许可您一项个人的、基于法定或约定事由可撤销的、不可转让的、非独占的和非商业的使用本服务进行内容输入并获得内容输出的权利。本协议未明示授权的其他一切权利仍由伴知宠保留，您在行使该些权利前须另行获得伴知宠的书面许可，同时伴知宠如未行使前述任何权利，并不构成对该权利的放弃。如果您对外发布或传播本服务生成的输出，您应当：
      </p>
      <p>（1）主动核查输出内容的真实性、准确性，避免传播虚假信息；</p>
      <p>（2）以显著方式标明该输出内容系由人工智能生成，以向公众提示内容合成的情况；</p>
      <p>（3）避免发布和传播任何违反本协议使用规范的输出内容。</p>

      <h2>五、服务内容</h2>
      <p>
        5.1 本公司可能为不同的终端设备及使用需求开发不同的应用程序软件版本，您应当根据实际设备及需求状况获取、下载、安装合适的版本。
      </p>
      <p>
        5.2
        <strong>
          本产品的服务具体内容根据实际情况提供，伴知宠保留变更、中断或终止部分或全部服务的权利。伴知宠不承担因业务调整给您造成的损失。除非本协议另有其它明示规定，增加或强化任何新功能，包括所推出的新产品，均受到本协议之规范。您了解并同意，本产品服务仅依其当前所呈现的状况提供，对于任何用户通讯或个人化设定之时效、删除、传递错误、未予储存或其它任何问题，伴知宠均不承担任何责任。如您不接受服务调整，请停止使用本服务；否则，您的继续使用行为将被视为您对调整服务的完全同意且承诺遵守
        </strong>
        。
      </p>
      <p>
        5.3 您理解，伴知宠仅提供相关的服务，除此之外与相关服务有关的设备（如电脑、调制解调器及其他与接入互联网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费）均应由您自行负担。
      </p>
      <p>
        5.4
        <strong>
          伴知宠提供的服务内容可能包括：文字、软件、声音、图片、视频、图表等。所有这些内容受著作权、商标和其它财产所有权法律的保护。您只有在获得伴知宠或其他相关权利人的授权之后才能使用这些内容，不能擅自复制、再造这些内容、或创造与内容有关的派生产品
        </strong>
        。
      </p>

      <h2>六、知识产权</h2>
      <p>
        6.1 本公司在“伴知宠”软件及相关服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、商标、标识、音频、视频、图表、版面设计、电子文档等）的知识产权属于本公司所有。同时本公司提供服务所依托的软件的著作权、专利权、商标及其他知识产权均归本公司所有。未经本公司许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载“伴知宠”软件及相关服务中的内容）。
      </p>
      <p>
        6.2 请您在任何情况下都不要私自使用本公司的包括但不限于“伴知宠”、"宠麻团"和“宠参谋”等在内的任何商标、服务标记、商号、域名、产品名称或其他显著品牌特征等（以下统称为“标识”）。未经本公司事先书面同意，您不得将本条款前述标识以单独或结合任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理该些标识的行为。由于您违反本协议使用本公司上述商标、标识等给本公司或他人造成损失的，由您承担全部法律责任。
      </p>
      <p>
        6.3 您确认并同意授权本公司以本公司名义或委托专业第三方对侵犯您上传发布的享有知识产权的内容进行代维权，维权形式包括但不限于：监测侵权行为、发送维权函、提起诉讼或仲裁、调解、和解等，本公司有权对维权事宜做出决策并独立实施。
      </p>
      <p>
        6.4 您理解并承诺，您在使用AI育宠顾问和AI生成视频服务时的输入不侵犯任何人的知识产权、肖像权、名誉权、荣誉权、姓名权、隐私权、个人信息权益等合法权益，不涉及任何国家秘密、商业秘密、重要数据或其他可能会对国家安全或者公共利益造成不利影响的数据，否则由此产生的侵权风险和责任由您承担。伴知宠由此遭受的全部直接和间接损失（包括但不限于经济、商誉、维权支出、律师费等损失）也同样由您承担。
      </p>

      <h2>七、隐私保护</h2>
      <p>
        7.1 保护用户隐私（请参见
        <Link to="/privacy-policy" className="agreement-link">
          《伴知宠隐私政策》
        </Link>
        ）是伴知宠的一项基本政策，伴知宠保证不对外公开或向第三方提供您的注册资料及您在使用本平台服务时存储在伴知宠的非公开内容，但下列情况除外：
      </p>
      <p>（1）事先获得您的明确授权；</p>
      <p>（2）根据有关的法律法规要求；</p>
      <p>（3）按照相关政府主管部门的要求；</p>
      <p>（4）为维护社会公众的利益；</p>
      <p>（5）维护伴知宠的合法权益。</p>
      <p>
        7.2 在获得您授权的情况下，伴知宠可能会与第三方合作向您提供相关的服务，在此情况下，如该第三方同意承担与伴知宠同等的保护用户隐私的责任，则伴知宠可将您的注册资料等提供给该第三方。
      </p>

      <h2>八、免责声明</h2>
      <p>
        8.1 您将照片、个人信息等资料公开发布到互联网上，有可能会被其他组织或个人复制、转载、擅改或做其它非法用途，用户必须充分意识此类风险的存在。
        <strong>
          您明确同意使用“伴知宠”软件及相关服务所存在的风险（包括但不限于受到第三方侵权或对第三方造成侵权）完全由您自己承担；因您使用“伴知宠”软件及相关服务而产生的一切后果也由您自己承担，伴知宠对此不承担任何责任
        </strong>
        。
      </p>
      <p>
        8.2
        <strong>
          伴知宠不担保本产品服务一定能满足您的要求，也不担保本产品服务不会中断，对本产品服务的及时性、安全性、准确性、真实性、完整性也都不作担保
        </strong>
        。
      </p>
      <p>
        8.3
        <strong>
          对于因不可抗力或伴知宠不能控制的原因造成的本产品服务中断或其它缺陷，伴知宠不承担任何责任，但伴知宠将尽力减少因此给您造成的损失和影响
        </strong>
        。
      </p>
      <p>
        8.4
        <strong>
          根据有关法律法规，伴知宠在此郑重提请您注意，伴知宠作为信息存储空间及网络交易平台的提供者，任何经由本软件以上载、张贴、发送电子邮件或任何其它方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息或其它资料（以下简称“内容”），无论系公开还是私下传送，均由内容提供者承担责任。伴知宠无法控制经由本产品传送之内容，因此不保证内容的正确性、完整性或品质。在任何情况下，伴知宠均不为任何内容负责，包含但不限于任何内容之任何错误或遗漏，以及经由本软件服务以张贴、发送电子邮件或其它方式传送任何内容而衍生之任何损失或损害。但伴知宠有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本软件服务的全部或部分，保存有关记录，并向有关机关报告
        </strong>
        。
      </p>
      <p>
        8.5
        <strong>
          人工智能和机器学习是快速发展的研究领域，伴知宠也在不断努力改进本服务，使其更加准确、可靠、安全、可信。但限于技术特性，伴知宠在尽到合理努力的前提下，仍无法完全保证您使用AI育宠顾问服务获得的输出的合法性、真实性、准确性以及完整性。您应对AI育宠顾问服务中的输出自行加以判断，并承担因使用内容引起的所有风险。我们提示您，除法律有明确规定外，伴知宠无法也不会对前述风险而导致的任何损失或损害承担责任
        </strong>
        。
      </p>

      <h2>九、违约责任</h2>
      <p>
        9.1 针对您违反本协议或其他服务条款的行为，本公司有权独立判断并视情况采取预先警示、拒绝发布、立即停止传输信息、删除内容或跟帖、短期禁止发布内容或评论、限制账号部分或者全部功能直至永久关闭账号等措施，对于因此造成您无法正常使用账号及相关服务、无法正常获取您账号内资产或其他权益等后果，本公司不承担任何责任。本公司有权公告处理结果，且有权根据实际情况决定是否恢复使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为将保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。
      </p>
      <p>
        9.2 因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行承担全部法律责任。因您的违法或违约行为导致本公司及关联公司、控制公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿本公司及关联公司、控制公司因此遭受的全部损失。
      </p>
      <p>
        9.3 本公司尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用”伴知宠”软件及相关服务时上传的文字、图片、视频、音频等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，本公司有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，您应自行处理并承担全部可能由此引起的法律责任；如因您的侵权行为导致本公司遭受损失的（包括经济、商誉等损失），您还应足额赔偿本公司遭受的全部损失。
      </p>

      <h2>十、未成年人保护条款</h2>
      <p>
        10.1
        <strong>
          若您是未满14周岁的未成年人，应在监护人监护、指导并获得监护人同意情况下阅读本协议和使用“伴知宠”软件及相关服务
        </strong>
        。
      </p>
      <p>
        10.2 伴知宠重视对未成年人个人信息的保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，
        <strong>并应当在取得监护人的同意以及在监护人指导下正确使用“伴知宠”软件及相关服务</strong>
        。
      </p>
      <p>
        10.3
        <strong>
          未成年人用户及其监护人理解并确认，如您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担因此可能导致的全部法律责任。
        </strong>
      </p>
      {/*<p>*/}
      {/*  10.4 对于未成年人的隐私保护，伴知宠将严格按照平台公布的《伴知宠儿童隐私保护政策》中阐述的方式、方法执行。*/}
      {/*</p>*/}

      <h2>十一、协议修改</h2>
      <p>
        11.1
        <strong>
          伴知宠有权根据法律法规政策、国家有权机构或本公司经营要求修改本协议的有关条款，伴知宠将会通过适当方式在平台上予以公示。
        </strong>
      </p>
      <p>
        11.2 若您不同意伴知宠对本协议相关条款所做的修改，您有权停止使用”伴知宠”软件及相关服务。如果您继续使用”伴知宠”软件及相关服务，则视为您接受伴知宠对本协议相关条款所做的修改。
      </p>

      <h2>十二、其他</h2>
      <p>
        12.1 本协议的订立、生效、履行、解释、修订、终止及纠纷解决，适用中华人民共和国法律（仅为本协议之目的，不包括香港特别行政区、澳门特别行政区和台湾地区）。
      </p>
      <p>
        12.2 本协议的签订地为中华人民共和国浙江省杭州市余杭区。若您与本公司发生任何争议，双方应尽量友好协商解决，如协商不成，您同意将争议提交至本协议签订地的人民法院诉讼解决。
      </p>
    </div>
  );
}
